import { render, staticRenderFns } from "./PeninsularTables.vue?vue&type=template&id=ebe404fe&"
import script from "./PeninsularTables.vue?vue&type=script&lang=js&"
export * from "./PeninsularTables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports